<app-block-list [blockIdList]="$any(header)"></app-block-list>
<div
  class="relative w-full flex-1 overflow-y-scroll px-32 md:mx-auto"
  [class.pb-52]="bottomPadding === 'auto'"
  [class.pb-8]="bottomPadding === 'small'"
  [class.pb-16]="bottomPadding === 'medium'"
  [class.pb-32]="bottomPadding === 'large'"
  [class.pb-44]="bottomPadding === 'xlarge'"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.backgroundImage]="backgroundImageCss"
  [style.backgroundSize]="backgroundImageCss ? 'cover' : null"
  [style.backgroundPosition]="backgroundImageCss ? 'center' : null"
  [style.backgroundRepeat]="backgroundImageCss ? 'no-repeat' : null"
>
  <app-block-list [blockIdList]="$any(content)"></app-block-list>
  <app-block-list [blockIdList]="$any(body)"></app-block-list>
  <app-block-list [blockIdList]="$any(bottomContent)"></app-block-list>
</div>
@if (steps()?.[0]?.block) {
  <div
    class="fixed bottom-0 left-0 right-0 w-full md:sticky"
    [style.background]="buttonsBackgroundColor | contentBuilderColor"
  >
    <div class="grid grid-cols-2 gap-10 p-10">
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        type="kiosk-light"
        [overrideBgColor]="cancelButtonBackgroundColor"
        [overrideTextColor]="cancelButtonTextColor"
        (click)="back()"
        [label]="'cart-funnel.buttons.cancel' | translate"
      ></app-button-atom>
      <app-button-atom
        size="XXL"
        thickSize="XXL"
        type="kiosk-primary"
        [overrideBgColor]="validateButtonBackgroundColor"
        [overrideTextColor]="validateButtonTextColor"
        (click)="submit()"
        [disabled]="!(isValid$ | async)"
        [label]="'cart-funnel.buttons.validate' | translate"
      ></app-button-atom>
    </div>
  </div>
}
